export default {"src":"/_next/static/media/public-user-price-chart.47c86dfb.svg","height":580,"width":858,"blurWidth":0,"blurHeight":0};